import React, { useState } from 'react'
import tinycolor from 'tinycolor2'

import { Checkbox, ColorPicker, Popper } from '@fourthwall/components'

import * as S from './styled'

type Props = {
  label: string
  color?: string
  defaultColor?: string
  onChange: (color?: string) => void
}

export const ColorInput = ({ label, color, defaultColor, onChange }: Props) => {
  const [isOpen, setOpen] = useState(false)

  return (
    <Popper
      isOpen={isOpen}
      referenceComponent={
        <S.Container onClick={() => setOpen((prevIsOpen) => !prevIsOpen)}>
          <S.ColorBoxContainer>
            <S.ColorBox style={{ backgroundColor: color || defaultColor }} />
          </S.ColorBoxContainer>
          {label}
        </S.Container>
      }
      popperProps={{
        placement: 'bottom-start',
      }}
      style={{ paddingTop: 8 }}
      onClose={() => setOpen(false)}
    >
      <ColorPicker
        color={color ? tinycolor(color).toRgbString() : defaultColor}
        position="bottom-start"
        format="RGB"
        showAlpha
        hexVisible
        onValueChange={onChange}
      />
      <S.CheckboxContainer>
        <Checkbox
          label="Use site's default color"
          value={!color}
          onValueChange={(value) => {
            if (value) {
              onChange(undefined)
            } else {
              onChange(defaultColor)
            }
          }}
        />
      </S.CheckboxContainer>
    </Popper>
  )
}
